"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsWidgetFilterMetricComparisonEnum = void 0;
var StatsWidgetFilterMetricComparisonEnum;
(function (StatsWidgetFilterMetricComparisonEnum) {
    StatsWidgetFilterMetricComparisonEnum["nEqNum"] = "not_equal_num";
    StatsWidgetFilterMetricComparisonEnum["EqNum"] = "equal_num";
    StatsWidgetFilterMetricComparisonEnum["Gt"] = "gt";
    StatsWidgetFilterMetricComparisonEnum["Gte"] = "gte";
    StatsWidgetFilterMetricComparisonEnum["Lt"] = "lt";
    StatsWidgetFilterMetricComparisonEnum["Lte"] = "lte";
    StatsWidgetFilterMetricComparisonEnum["AnyOfNum"] = "any_of_num";
    StatsWidgetFilterMetricComparisonEnum["NoneOfNum"] = "none_of_num";
})(StatsWidgetFilterMetricComparisonEnum = exports.StatsWidgetFilterMetricComparisonEnum || (exports.StatsWidgetFilterMetricComparisonEnum = {}));
